export const MESSAGE_ACTION_TYPE = {
    ADD_MESSAGE: 'ADD_MESSAGE',
    UPDATE_MESSAGES: 'UPDATE_MESSAGES',
    DELETE_MESSAGE: 'DELETE_MESSAGE',
    SET_MESSAGES: 'SET_MESSAGES',
};

const initialState = [];

export const addMessage = (message) => ({
    type: MESSAGE_ACTION_TYPE.ADD_MESSAGE,
    payload: message,
});

export const updateMessages = (messages) => ({
    type: MESSAGE_ACTION_TYPE.UPDATE_MESSAGES,
    payload: messages,
});

export const deleteMessage = (index) => ({
    type: MESSAGE_ACTION_TYPE.DELETE_MESSAGE,
    payload: index,
});

export const setMessages = (messages) => ({
    type: MESSAGE_ACTION_TYPE.SET_MESSAGES,
    payload: messages,
});

const inAppMessagesReducer = (state = initialState, action) => {
    switch (action.type) {
        case MESSAGE_ACTION_TYPE.ADD_MESSAGE:
            return [action.payload, ...state];
        case MESSAGE_ACTION_TYPE.UPDATE_MESSAGES:
            return action.payload;
        case MESSAGE_ACTION_TYPE.DELETE_MESSAGE:{
            const indexToDelete = action.payload;
            return [
                ...state.slice(0, indexToDelete),
                ...state.slice(indexToDelete+1)
            ];

        }
        case MESSAGE_ACTION_TYPE.SET_MESSAGES:
            return action.payload;
        default:
            return state;
    }
};

export default inAppMessagesReducer;